module.exports = __webpack_public_path__ + "static/media/course.dc3dda8c.svg";